module.exports = __webpack_public_path__ + "img/camas-white.0f33d968.svg";